import { FoodManagementControls } from "../types";

export const controlsWithMultipleInstances: FoodManagementControls[] = [
  FoodManagementControls.goodsReceipt,
  FoodManagementControls.heatingTreatment,
  FoodManagementControls.heatRetetion,
  FoodManagementControls.coolingFood,
  FoodManagementControls.reheatingFood,
];
